'use strict';

angular.module('far.gallery')
.controller('GalleryEditController', function(gallery, FileUploader) {
	var uploader = new FileUploader({
		autoUpload: true,
		filters: [{
			name: 'images',
			fn: function(item) {
				return (/\.(gif|jpg|jpeg|tiff|png)$/i).test(item.name);
			}
		}],
		onSuccessItem: function (item, response) {
			item.server = response;
		}
	});

	var vm = {
		getGallery: getGallery,
		uploader: uploader,
		gallerySave: gallerySave
	};

	function getGallery(term, id) {
		vm.gallery = gallery(term, id);
		vm.uploader.url = Routing.generate('api_gallery_post_gallery_object_item', {term: vm.gallery.term, id: vm.gallery.id});
	}

	function gallerySave() {
		var newItems = uploader.queue
			.filter(function(item) {
				return item.isUploaded;
			})
			.map(function(item) {
				return item.server;
			});
		uploader.clearQueue();

		Array.prototype.push.apply(vm.gallery, newItems);

		vm.gallery.save();
	}

	return vm;
});